var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "academicDegreeRecord" }, [
    _c(
      "div",
      { staticClass: "academicDegreeRecord-box" },
      [
        _c(
          "div",
          { staticClass: "title-box" },
          [_c("Title", { attrs: { text: "学位申请记录", isShowBack: true } })],
          1
        ),
        _vm.isShowTable
          ? _c(
              "el-table",
              {
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: {
                  "header-cell-style": {
                    background: "#eef1f6",
                    color: "#606266",
                  },
                  data: _vm.tableData,
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "is_issue",
                    align: "center",
                    label: "是否发放证书",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.is_issue == 1 ? "是" : "否")
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2823984519
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "audit_status",
                    align: "center",
                    label: "审核状态",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm._f("auditStatusStyle")(
                                    scope.row.audit_status
                                  ),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("auditStatusFilter")(
                                        scope.row.audit_status
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1303075108
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "audit_content",
                    align: "center",
                    label: "拒绝理由",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "is_issue",
                    align: "center",
                    label: "发放证书状态",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm._f("isIssueStatusStyle")(
                                    scope.row.is_issue
                                  ),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("isIssueFilter")(
                                        scope.row.is_issue
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2307247024
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "student_title",
                    align: "center",
                    label: "学生姓名",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [_vm._v(_vm._s(row.student_title))]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1721359890
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "source_type",
                    align: "center",
                    label: "学生来源",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("sourceTypeFilter")(
                                    scope.row.source_type
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3725622528
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "tel", align: "center", label: "移动电话" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "sex_title", align: "center", label: "性别" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "nat_title", align: "center", label: "民族" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "pol_title",
                    align: "center",
                    label: "政治面貌",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "date_birth",
                    align: "center",
                    label: "出生日期",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "identity", align: "center", label: "身份证" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "pro_title",
                    align: "center",
                    label: "专业名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "degree_title",
                    align: "center",
                    label: "学位名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "exam_number",
                    align: "center",
                    label: "考生号或准考证号",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "student_code",
                    align: "center",
                    label: "学号",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "edu_system", align: "center", label: "学制" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "study_title",
                    align: "center",
                    label: "学习形式",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "admission_date",
                    align: "center",
                    label: "入学年月",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "gra_date",
                    align: "center",
                    label: "毕业年月",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "english_at",
                    align: "center",
                    label: "学位英语考试时间",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "english_score",
                    align: "center",
                    label: "英语成绩",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "english_img",
                    align: "center",
                    label: "学位英语考试合格证照片",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.$base.isNull(scope.row.english_img)
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: scope.row.english_img,
                                    "preview-src-list": [scope.row.english_img],
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3589375136
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "computer_at",
                    align: "center",
                    label: "计算机等级考试时间",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "computer_score",
                    align: "center",
                    label: "计算机成绩",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "computer_img",
                    align: "center",
                    label: "计算机等级考试合格证照片",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.$base.isNull(scope.row.computer_img)
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: scope.row.computer_img,
                                    "preview-src-list": [
                                      scope.row.computer_img,
                                    ],
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    178807317
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "computer_img",
                    align: "center",
                    label: "学位证书用电子照片",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.$base.isNull(scope.row.degree_img)
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: scope.row.degree_img,
                                    "preview-src-list": [scope.row.degree_img],
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    420436582
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "average_score",
                    align: "center",
                    label: "平均成绩",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paper_score",
                    align: "center",
                    label: "论文成绩",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "score_img",
                    align: "center",
                    label: "成绩总表",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.$base.isNull(scope.row.score_img)
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: scope.row.score_img,
                                    "preview-src-list": [scope.row.score_img],
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3771193210
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "grad_img",
                    align: "center",
                    label: "毕业证内页照",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.$base.isNull(scope.row.grad_img)
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: scope.row.grad_img,
                                    "preview-src-list": [scope.row.grad_img],
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3716250594
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "remark", align: "center", label: "备注" },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "操作",
                    "min-width": "140",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.audit_status == 2
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToDegreeApplication(
                                          row,
                                          "edit"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("去修改")]
                                )
                              : _vm._e(),
                            row.audit_status == 2
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToDegreeApplication(
                                          row,
                                          ""
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("重新提交")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2189898315
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }